import { useEffect, useRef, useState } from "react";

export default function SelectionDropdown({ label, value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const close = () => { setOpen(false); trigger.current?.focus(); };
  useEffect(() => {
    if (!open) return undefined;
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener("pointerdown", outside);
    (root.current?.querySelector('[aria-selected="true"]:not(:disabled)') || root.current?.querySelector('[role="option"]:not(:disabled)'))?.focus();
    return () => document.removeEventListener("pointerdown", outside);
  }, [open]);
  return <div className="productSelectionDropdown" ref={root} onKeyDown={event => {
    if (event.key === "Escape") { event.preventDefault(); event.stopPropagation(); close(); }
    if (open && ["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
      event.preventDefault();
      const enabled = [...root.current.querySelectorAll('[role="option"]:not(:disabled)')];
      const index = enabled.indexOf(document.activeElement);
      const next = event.key === "Home" ? 0 : event.key === "End" ? enabled.length - 1 : (index + (event.key === "ArrowDown" ? 1 : -1) + enabled.length) % enabled.length;
      enabled[next]?.focus();
    }
  }}>
    <button type="button" id="v153PersistentSelect" ref={trigger} aria-label={label} aria-haspopup="listbox" aria-expanded={open}
      onClick={() => setOpen(!open)} onKeyDown={event => { if (event.key === "ArrowDown") { event.preventDefault(); setOpen(true); } }}>{value || "–"}</button>
    {open && <div className="productSelectionMenu" role="listbox" aria-label={label}>
      {[{ value: "", label: "–" }, ...options].map(option => <button type="button" role="option" key={option.value} disabled={option.disabled} aria-selected={value === option.value}
        onClick={() => { onChange(option.value); close(); }}><span>{option.label}</span><span aria-hidden="true">{value === option.value ? "✓" : ""}</span></button>)}
    </div>}
  </div>;
}
